<template>
  <div>
    <Topside />
    <div class="main">
      <RepoSearch />
      <ul class="database-btn">
        <li v-for="(item, index) in this.$store.getters.kaiso1tbl" :key="index">
          <a href="javascript:void(0);" @click="clickData(item)">{{item.Title}}</a>
        </li>
      </ul>
    </div>
  </div>

</template>
<script>
import Topside from '@/components/Treeside.vue'
import RepoSearch from '@/components/RepoSearch'
import axios from 'axios'

export default {
  name: 'home',
  components: {
    Topside,
    RepoSearch
  },
  data() {
    return {
      kaisodata: []
    }
  },
  created() {
    this.getAllKaisoData(function(res) {})
  },
  methods: {
    clickData(item) {
      this.$store.dispatch('upOpenMenuId', `${item.Code1}/${item.Code2}`)
      this.$router.push(`/database/${item.Code1}/${item.Code2}`)
    }
    /*
     getAllKaisoData() {
      var self = this
      if(self.$store.getters.kaiso1tbl.length > 0)
        {
            return true; 
        }
      axios
        .get(`${app.baseURI}kaiso.json`)
        .then(res => {
          self.$store.dispatch('upKaiso1tbl', res.data.kaiso1tbl)
          self.$store.dispatch('upKaiso2tbl', res.data.kaiso2tbl)
          self.$store.dispatch('upKaiso3tbl', res.data.kaiso3tbl)
          return true
        })
        .catch(res => {
          return false
        })
    },
    */
  }
}
</script>
